// JavaScript Document

import transition from "transition-to-from-auto";

const MENUS = document.querySelectorAll(".weblinx-menu-list[data-display][data-input]");

const CLOSE_ITEM = (item, menu, event, input, display) => {
    /**
     * Close all descendants
     */
    item.querySelectorAll(":scope > .weblinx-menu-list__item:has(.weblinx-menu-container)").forEach((i) => {
        i.classList.remove("weblinx-menu-list__item--state-active");
    });

    /**
     * Close the item
     */
    item.classList.remove("weblinx-menu-list__item--state-active");

    /**
     * Update aria-hidden
     */
    item.querySelector(".weblinx-menu-container").setAttribute("aria-hidden", "true");

    /**
     * Transition accordions closed
     */
    if (display === "accordion") {
        transition({ element: item.querySelector(".weblinx-menu-container--accordion"), val: 0 });
    }
};

const OPEN_ITEM = (item, menu, event, input, display) => {
    /**
     * Prevent navigation on initial click and touch
     */
    if (["click", "touch"].includes(input) && event !== null) {
        event.preventDefault();
    }

    /**
     * Close all items, except this one, and descendants
     */
    menu.querySelectorAll(".weblinx-menu-list__item:has(.weblinx-menu-container)").forEach((i) => {
        if (i !== item && ! i.contains(item) && ! item.contains(i)) {
            CLOSE_ITEM(i, menu, null, input, display);
        }
    });

    /**
     * Open the item
     */
    item.classList.add("weblinx-menu-list__item--state-active");

    /**
     * Update aria-hidden
     */
    item.querySelector(":scope > .weblinx-menu-container").setAttribute("aria-hidden", "false");

    /**
     * Transition accordions open
     */
    if (display === "accordion") {
        transition({ element: item.querySelector(":scope > .weblinx-menu-container--accordion"), val: "auto" });
    }

    /**
     * Reverse overlay if it'll be off screen
     */
    if (display === "overlay") {
        const CONTAINER = item.querySelector(":scope > .weblinx-menu-container--overlay");

        CONTAINER.classList.remove("weblinx-menu-container--reverse");

        const RECT   = CONTAINER.getBoundingClientRect();
        const OFFSET = RECT.left + RECT.width;

        if (OFFSET > window.innerWidth) {
            CONTAINER.classList.add("weblinx-menu-container--reverse");
        }
    }
};

MENUS.forEach((menu) => {
    const DISPLAY = menu.dataset.display;
    const AUTO    = JSON.parse(menu.dataset.auto);
    const INPUT   = JSON.parse(menu.dataset.input);

    /**
     * None of this applies for "inline" menus.
     */
    if (DISPLAY === "inline") {
        return;
    }

    /**
     * Find all parent items
     */
    const ITEMS = menu.querySelectorAll(":scope > .weblinx-menu-list__item:has(.weblinx-menu-container)");

    ITEMS.forEach((item) => {
        /**
         * Handle toggle
         */
        if (INPUT.includes("toggle")) {
            const TOGGLE = item.querySelector(":scope > .weblinx-menu-list__toggle");

            if (TOGGLE) {
                TOGGLE.addEventListener("click", (e) => {
                    if (item.classList.contains("weblinx-menu-list__item--state-active")) {
                        CLOSE_ITEM(item, menu, e, "toggle", DISPLAY);
                    } else {
                        OPEN_ITEM(item, menu, e, "toggle", DISPLAY);
                    }
                }, { passive: false });
            }
        }

        /**
         * Handle click
         */
        if (INPUT.includes("click")) {
            item.querySelector(":scope > .weblinx-menu-list__link").addEventListener("click", (e) => {
                if (! item.classList.contains("weblinx-menu-list__item--state-active")) {
                    OPEN_ITEM(item, menu, e, "click", DISPLAY);
                }
            }, { passive: false });
        }

        /**
         * Handle touch
         */
        if (INPUT.includes("touch")) {
            item.querySelector(":scope > .weblinx-menu-list__link").addEventListener("touchstart", (e) => {
                if (! item.classList.contains("weblinx-menu-list__item--state-active")) {
                    OPEN_ITEM(item, menu, e, "click", DISPLAY);
                }
            }, { passive: false });
        }

        /**
         * Handle focus
         */
        if (INPUT.includes("focus")) {
            item.addEventListener("focusin", (e) => {
                OPEN_ITEM(item, menu, e, DISPLAY, INPUT);
            }, { passive: true });

            item.addEventListener("focusout", (e) => {
                CLOSE_ITEM(item, menu, e, DISPLAY, INPUT);
            }, { passive: true });
        }

        /**
         * Handle hover
         */
        if (INPUT.includes("hover")) {
            item.addEventListener("mouseover", (e) => {
                OPEN_ITEM(item, menu, "hover", e, DISPLAY);
            }, { passive: true });

            item.addEventListener("mouseleave", (e) => {
                CLOSE_ITEM(item, menu, "hover", e, DISPLAY);
            }, { passive: true });
        }
    });

    /**
     * Close the menu when it loses focus
     */
    document.addEventListener("click", (e) => {
        if (! menu.contains(e.target) && AUTO.includes("close") && menu.querySelector(".weblinx-menu-list__item--state-active")) {
            [...ITEMS].reverse().forEach((item) => {
                if (item.classList.contains("weblinx-menu-list__item--state-active")) {
                    CLOSE_ITEM(item, menu, null, INPUT, DISPLAY);
                }
            });
        }
    }, { passive: true });

    /**
     * Open the menu on load
     * @note disabled because this is done in PHP instead
     */
    if (AUTO.includes("open")) {
        const ITEM = menu.querySelector(".weblinx-menu-list__item--canonical.weblinx-menu-list__item--state-current");

        if (ITEM) {
            const PARENTS = ITEM.closest(".weblinx-menu-list[data-auto]").querySelectorAll(".weblinx-menu-list__item:has(.weblinx-menu-container)");

            PARENTS.forEach((item) => {
                if (item === ITEM || item.contains(ITEM)) {
                    OPEN_ITEM(item, menu, null, INPUT, DISPLAY);
                }
            });
        }
    }

    /**
     * Handle the overflow menu
     */
    if (menu.dataset.overflow === "true") {
        const BUTTON = menu.nextElementSibling;

        let resizing = false;

        const RESIZE_OBSERVER = new ResizeObserver(entries => {
            /**
             * If currently resizing, return
             */
            if (resizing) {
                return;
            }

            /**
             * If the toggle isn't present, return
             */
            if (BUTTON && ! BUTTON.classList.contains("weblinx-menu-container__weblinx-panel-toggle")) {
                return;
            }

            resizing = true;

            for (const ENTRY of entries) {
                let items_width = 0;

                /**
                 * Get the button width
                 */
                // const BUTTON_STYLE = window.getComputedStyle(BUTTON);
                // const BUTTON_WIDTH = BUTTON.offsetWidth + (isNaN(parseFloat(BUTTON_STYLE.marginLeft)) ? 0 : parseFloat(BUTTON_STYLE.marginLeft)) + (isNaN(parseFloat(BUTTON_STYLE.marginRight)) ? 0 : parseFloat(BUTTON_STYLE.marginRight));

                /**
                 * Get the items and their clones
                 */
                const ITEMS  = Array.from(menu.querySelectorAll(".weblinx-menu-list[data-overflow='true'] > .weblinx-menu-list__item"));
                const CLONES = Array.from(menu.parentElement.querySelectorAll(".weblinx-menu-container__weblinx-panel--overflow > .weblinx-panel__inner > .weblinx-menu-list > .weblinx-menu-list__item"));

                /**
                 * Reset
                 */
                ITEMS.forEach(item => item.style.display = "");

                /**
                 * Hide the items that are overflowing
                 */
                for (let i = 0; i < ITEMS.length; i++) {
                    items_width += ITEMS[i].offsetWidth;

                    /**
                     * If overflowing, hide the item and show the clone
                     */
                    if (items_width > ENTRY.contentRect.width) {
                        ITEMS[i].style.display = "none";
                        CLONES[i].style.display = "";
                    } else {
                        CLONES[i].style.display = "none";
                    }

                    /**
                     * Adjust the display state of the toggle button
                     */
                    if (i === CLONES.length - 1) {
                        /**
                         * Sync the toggle button's display state
                         */
                        BUTTON.style.display = CLONES[i].style.display;

                        /**
                         * Close the panel if all items are hidden
                         */
                        if (CLONES[i].style.display === "none" && BUTTON.classList.contains("is-active")) {
                            BUTTON.click();
                        }

                        /**
                         * Initialize the toggle button
                         */
                        if (! BUTTON.classList.contains("is-initialized")) {
                            BUTTON.classList.add("is-initialized");
                        }
                    }
                }
            }

            resizing = false;
        });

        if (menu) {
            RESIZE_OBSERVER.observe(menu);
        }
    }
});
